export default __webpack_public_path__ + "static/sports-bar-b88778ce53a456154dabec146f4ed2b8.jpg";